import { useEffect, useState } from 'react';
import { standardDrawing } from '@moleculeone/draw';
import { expandToMinSize, V4 } from '@moleculeone/utils';
import { Mol, DrawnMol, Vector } from '@retro-ui/api-contract';

const wait = (ms: number) =>
  new Promise<void>(resolve => {
    setTimeout(() => {
      resolve();
    }, ms);
  });

interface MolDrawingArgs {
  mol: Mol;
  renderDelay?: number;
}

interface MolDrawingResult {
  drawnMol: DrawnMol;
  viewport: {
    max: Vector;
    min: Vector;
  };
}

export const useMolDrawing = ({ mol, renderDelay = 0 }: MolDrawingArgs) => {
  const [drawing, setDrawing] = useState<MolDrawingResult>();

  useEffect(() => {
    async function calculate() {
      await wait(renderDelay);
      const drawnMol = standardDrawing(mol) as DrawnMol;
      const bbox = drawnMol.bbox;
      const viewport = expandToMinSize(bbox, V4.fromArray([24, 24, 0]));
      setDrawing({ drawnMol, viewport });
    }
    calculate();
  }, [mol]);

  return drawing;
};
